import React from "react";
import { Button, Card } from "react-bootstrap";
import { excelExport } from "../../utils/excel-export";
import axios from "axios";
import { createAxiosInstance } from "../../utils/axios-instance";
import { useMsal } from "@azure/msal-react";

export default function AuditReport() {
  const [processing, setProcessing] = React.useState(false);
  const { instance } = useMsal();

  const runAuditReport = (data) => {
    setProcessing(true);
    const axiosInstance = createAxiosInstance(instance);
    axiosInstance
      .post(`${process.env.REACT_APP_API_ENDPOINT}compliance/report/all`, {})
      .then((response) => {
        console.log("Audit report data:", response.data);
        excelExport(response.data, "Audit");
      })
      .finally(() => {
        setProcessing(false);
      });
  };

  return (
    <div className="m-2">
      <Card className="p-2">
        <Card.Header>
          <Card.Title as="h3">Audit Report</Card.Title>
        </Card.Header>
        <Card.Body>
          <p>This report provides a list of all requests submitted.</p>
          <ul>
            <li>Time and Date Submitted</li>
            <li>Time and Date Responded</li>
            <li>Question and Response Count</li>
            <li>
              Automatic Flag those that are past 10 days and reaching 14 days
            </li>
          </ul>
          <Button
            disabled={processing}
            onClick={runAuditReport}
            variant="primary btn-fill"
          >
            <span>{processing ? "Processing..." : "Run Audit Report"}</span>
          </Button>
        </Card.Body>
      </Card>
    </div>
  );
}
